import { FC } from 'react';
import { ArrowLongRightIcon } from '@heroicons/react/24/outline';
import Image from 'components/commercetools-ui/atoms/image';
import Typography from 'components/commercetools-ui/atoms/typography';
import useImageSizes from 'helpers/hooks/useImageSizes';
import { MultiPageContentPageProps } from './types';
import Link from '../../atoms/link';

const MultiPageContentPage: FC<MultiPageContentPageProps> = ({
  image,
  title,
  ctaLabel,
  summary,
  ctaReference,
  className,
}) => {
  const tileImageSizes = useImageSizes({ md: 1, lg: 0.33, defaultSize: 0.33 });

  return (
    <div className={`${className} mb-16 flex size-full min-h-220 flex-col md:mb-32 md:flex-row`}>
      {image && (
        <div className="h-auto w-full pb-16 md:absolute md:-top-120 md:right-0 md:h-356 md:w-1/2 md:pb-0">
          <Image
            {...image}
            sizes={tileImageSizes}
            className="!relative h-full rounded-md object-cover md:object-contain md:px-32"
            fill
          />
        </div>
      )}
      <div className="flex size-full flex-col justify-start md:w-1/2">
        {title && (
          <Typography
            as="h4"
            className="max-w-[90%] overflow-hidden text-ellipsis whitespace-pre text-xl font-medium text-primary-black"
          >
            {title}
          </Typography>
        )}
        {summary && <Typography className="my-24 leading-[24px]">{summary}</Typography>}
        {ctaLabel && (
          <Link
            link={ctaReference}
            className="text-gray-700 hover:text-blue-600 focus:text-blue-600 active:text-blue-600"
          >
            <Typography className="text-base underline">{ctaLabel}</Typography>
          </Link>
        )}
      </div>
    </div>
  );
};

export default MultiPageContentPage;
